define('formkit/view/form.object/rule/condition.item.view',['require','exports','module','underscore','uikit/uikit','../../../templates','./rule.target.modal.view'],function(require, exports, module){
  var _                   = require('underscore');
  var UIKit               = require('uikit/uikit');
  var Templates           = require('../../../templates');
  var RuleTargetModalView = require('./rule.target.modal.view');

  var ConditionItemView = UIKit.ItemView.extend({
    template: function(){
      return '<ui type="form" name="formView" />';
    },

    internalViewOptions: {
      targetObjectInputView: function(){
        return {
          type: UIKit.Input.extend({
            triggers: _.extend({}, UIKit.Input.prototype.triggers, {
              'click': {
                event: 'press',
                preventDefault: false,
                stopPropagation: false
              }
            })
          }),
          placeholder: 'Rule Target',
          readonly: true,
          model: this.form.getTemplateObjectById(this.model.get('targetId')),
          bindings: {
            value: 'text'
          }
        }
      },
      operatorDropdownView: function() {
        return {
          type: UIKit.Dropdown,
          collection: this.form ? this.form.operations : null,
          childBindings: { text: 'displayName' },
          dropdownValue: function(value, collection, model) {
            return collection ? collection.findWhere({ name: value }) : null;
          },
          modelValue: function(model, collection) {
            return model ? model.get('name') : null;
          },
          model: this.model,
          bindings: { value: 'operation' }
        }
      },
      settingsButtonView: function() {
        return {
          type: UIKit.Button,
          model: this.model,
          icon: 'setting',
          color: 'primary'
        }
      },
      addButtonView: function(){
        return {
          type: UIKit.Button,
          collection: this.model,
          icon: 'add'
        }
      },
      removeButtonView: function(){
        return {
          type: UIKit.Button,
          collection: this.model,
          icon: 'minus'
        }
      }
    },

    onInjectedFormView: function(){
      this.setupForm();
    },

    setupForm: function() {
      var buttonContainerView = new UIKit.Container({
        className: 'ui buttons'
      });

      buttonContainerView.add(this.settingsButtonView = this.buildComponent({ name: 'settingsButtonView' }));
      buttonContainerView.add(this.addButtonView = this.buildComponent({ name: 'addButtonView' }));
      buttonContainerView.add(this.removeButtonView = this.buildComponent({ name: 'removeButtonView' }));

      this.formView
        .addGroup()
          .addField({ width: 7, text: '' }, this.targetObjectInputView = this.buildComponent({ name: 'targetObjectInputView' })).parent()
          .addField({ width: 5, text: '' }, this.operatorDropdownView = this.buildComponent({ name: 'operatorDropdownView' })).parent()
          .addField({ width: 4 }, buttonContainerView)
        .parent();


      this.setupTargetObjectInputView();
      this.setupSettingsButtonView();
      this.setupAddButtonView();
      this.setupRemoveButtonView();
    },

    setupTargetObjectInputView: function() {
      this.listenTo(this.targetObjectInputView, 'press', function() {
        this.updateValuesFromRuleTargetModal();
      });
    },

    setupSettingsButtonView: function(){
      this.listenTo(this.settingsButtonView, 'press', function() {
        this.updateValuesFromRuleTargetModal();
      });
    },

    setupAddButtonView: function(){
      this.listenTo(this.addButtonView, 'press', function(){
        this.triggerMethod('add:condition');
      });
    },

    setupRemoveButtonView: function(){
      this.listenTo(this.removeButtonView, 'press', function(){
        this.triggerMethod('remove:condition', this.model);
      });
    },

    displayRuleTargetModal: function() {
      var ruleTargetModal = new RuleTargetModalView({
        form: this.form,
        checkedModel: this.form.getTemplateObjectById(this.model.get('targetId'))
      });

      _.defer(function() {
        ruleTargetModal.visible = true;
      });

      return ruleTargetModal;
    },

    updateValuesFromRuleTargetModal: function() {
      this.displayRuleTargetModal().on('templateObject:selected', function(selectedTemplateObject){
        this.model.set('targetId', selectedTemplateObject.id);
        this.model.set('templateObject', selectedTemplateObject);

        this.targetObjectInputView.model  = selectedTemplateObject;
      }, this);
    }
  });

  module.exports = ConditionItemView;
});

